var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 1200",
    style: {
      enableBackground: "new 0 0 1200 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#7B9D81;}\r\n\t.st1{fill:#657F68;}\r\n\t.st2{fill:#9FC9A3;}\r\n\t.st3{fill:#72684E;}\r\n\t.st4{fill:#51452D;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M687.8,225.7C584.2,225.7,414,50,334.5,50S218,148,249.4,284.9s22.2,203.5,22.2,203.5s-22.2-14.8-55.5-14.8 s-99.9,25-99.9,143.8s68.4,435.2,173.9,435.2s458.8,0,542,0s116.5-86.5,142.4-190.3s49.7-186.9,74.1-216.7 c23.1-28.2,35.1-50.2,35.1-87.2s-31.3-59-77.6-59c-46.2,0-94.1,34.4-94.1,34.4c0-53.6,36.5-158.4,36.5-265.7 c0-88.8-99.7-96.3-177.6-55.5C745.4,226.2,687.8,225.7,687.8,225.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M806.8,699.1c0-90.6,105.4-165.2,105.4-165.2c21-17,62.3-34.1,104.2-34.1s67.5,22.7,67.5,58.6 s-2.6,50.9-35.1,87.2c-32.6,36.2-77.7,230.7-95.3,289.3s-55.3,117.4-112.9,117.4c-57.5,0-455.8,0-556,0S116.3,731.6,116.3,610.8 s72.2-137.2,99.8-137.2s55.5,14.8,55.5,14.8s49.9,20.3,37,196.1c0,0,189.9,19.9,241.3,27.9c50.4,7.9,145.1-22.3,232.3-16.4 c1.7,0.1,3.4,0.1,5,0.4C806.8,699.1,806.8,699.1,806.8,699.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266,718c0,35,9.4,166.3,42.6,186.6s59.1,22.2,240.4,22.2s255.3-3.7,275.6-14.8s35.1-125.8,35.1-162.8 s-38.8-53.6-90.6-53.6s-162.8,14.8-206.3,14.8s-195.2-25.9-237.7-25.9S266,697.7,266,718z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266,718c0,0,92.3-16.9,224.8,8.1c202.6,38.3,254.4-37,363.1,0.6c0,0,4.4-18.8-56.1-29.2 c-60.6-10.4-168.5,12.9-234.8,12.9s-185.7-25.9-227.2-25.9S264.6,683.8,266,718z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M284.5,1116.2c0,18.6,15.2,33.8,33.8,33.8c18.6,0,33.8-15.2,33.8-33.8v-63.6l-67.5-0.3L284.5,1116.2 L284.5,1116.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M378.9,1089.9c0,13.2,10.8,24,24,24h2.8c13.2,0,24-10.8,24-24v-37.2h-50.9v37.2H378.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M697.3,1089.9c0,13.2,10.8,24,24,24h2.8c13.2,0,24-10.8,24-24v-37.2h-50.9L697.3,1089.9L697.3,1089.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M773,1052.6v63.6c0,18.6,15.2,33.8,33.8,33.8s33.8-15.2,33.8-33.8v-63.6H773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M352.1,1080.8v-28.1l-67.5-0.3v36.4C307,1085.8,329.5,1083.4,352.1,1080.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M429.8,1069.9v-17.3h-50.9v24.9C395.9,1075.4,412.9,1073,429.8,1069.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M746.3,1063.9c0.6-0.1,1.3-0.1,1.9-0.1v-11.1h-50.9v21.3C713.5,1069.8,729.7,1066.2,746.3,1063.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M840.5,1073.6v-21H773v34.3C795.7,1083.1,818.4,1079.6,840.5,1073.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9cae6c95.svg";
export { ForwardRef as ReactComponent };